export const BehaviourField = {
  Bhv_Generosity: 'Bhv_Generosity',
  Bhv_Passion: 'Bhv_Passion',
  Bhv_Solidarity: 'Bhv_Solidarity',
  Bhv_Curiosity: 'Bhv_Curiosity',
  Bhv_Boldness: 'Bhv_Boldness',
  Bhv_FairTreatment: 'Bhv_FairTreatment',
  Bhv_IntegratingDifferences: 'Bhv_IntegratingDifferences',
  Bhv_DecisionMaking: 'Bhv_DecisionMaking',
  Bhv_PsychologicalSafety: 'Bhv_PsychologicalSafety',
  Bhv_Trust: 'Bhv_Trust',
  Bhv_Belonging: 'Bhv_Belonging',
};
